<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Login using Portal Credentials</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email"
                                  v-model="user"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password"
                                  autocomplete="current-password" v-model="pass"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="login">Login</b-button>
                    </b-col>


                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>

          </b-card-group>
        </b-col>
      </b-row>
    </div>

    <Loading
      :show="loading"
      :label="loadingLabel">
    </Loading>
  </div>
</template>

<script>
  import store from './store';
  import Loading from 'vue-full-loading';
  import SSR from './ssr';

  const baseUrl = 'https://dev-xprtbackend.heartlandcommerce.com';


  export default {
    name: 'Login',
    mixins: [SSR],
    components: {Loading},

    data() {
      return {
        user: '',
        pass: '',
        loading: false,
        loadingLabel: "Authenticating with Portal..",
        store: store
      }
    },

    created() {
      if (!this.portalBaseURL) {
        this.loadingLabel = "Reaching out to SSR..";
        this.loading = true;


        this.getBaseUrls()
          .then(() => {
            this.loading = false;
          })
      }
    },

    beforeRouteEnter: function (to, from, next) {
      let token = store.getPersonToken();

      if (token) {
        next({path: '/'});
      } else {
        next();
      }
    },

    methods: {
      login() {
        this.loadingLabel = "Authenticating with Portal..";
        this.loading = true;

        this.$http.post(`${this.portalBaseURL}/token`, {user: this.user, password: this.pass})
          .then(res => {
            this.store.setPersonToken(res.body);
            this.loading = false;

            this.$router.push({path: '/'});

          }, () => {
            this.loading = false;
          });
      }
    }
  }
</script>
